<template>
	<div class="transfer_box">
        <!-- 查看详情 -->
        <el-dialog :title="$t('other.a1508')" :visible.sync="dialogTableVisible" width="60%">
			<div style="font-size:18px;font-weight:bold;margin-bottom:10px">
			<i v-show="sellerpurchaseAmout !== actualAmout" class="iconfont icon-jinggao1 vbfkh"></i>
			<i v-show="sellerpurchaseAmout == actualAmout" class="iconfont icon-gouSolid-copy vbfk"></i>
			<span v-show="sellerpurchaseAmout == actualAmout" style="color:rgb(0, 199, 163)">{{$t('other.a2748')}}（{{sellerpurchaseAmout}}）{{$t('other.a2749')}}（{{actualAmout}}）{{$t('other.a1505')}}！</span>
			<span v-show="sellerpurchaseAmout !== actualAmout" style="color:rgb(255, 82, 69)">{{$t('other.a2748')}}（{{sellerpurchaseAmout}}）{{$t('other.a2749')}}（{{actualAmout}}）{{$t('other.a1506')}}{{Math.abs(sellerpurchaseAmout-actualAmout)}}{{$t('other.a1337')}}！</span>
		</div>
			<el-table :data="itemDetail" height="450px" border>
				<el-table-column width="80" :show-overflow-tooltip="true">
					<template slot-scope="scrop">
                        <div class="picbox">

                        <img :src='scrop.row.storeItem ? scrop.row.storeItem.image : null'  style="width:100%">
                        </div>
					</template>
				</el-table-column>
				<el-table-column property="cusCode" :label="$t('sellerpurchase').cusCode" width="100" :show-overflow-tooltip="true"></el-table-column>
				
				<el-table-column property="storeItem.skuName" label="sku" width="100" :show-overflow-tooltip="true"></el-table-column>
				<el-table-column property="oldQuantity" :label="$t('other.a2750')"  :show-overflow-tooltip="true"></el-table-column>
				<el-table-column property="newQuantity" :label="$t('other.a2751')"  :show-overflow-tooltip="true">
					<template slot-scope="scrop">
					<span :class="{'cbkbf': scrop.row.oldQuantity !== scrop.row.newQuantity ? true : false}">{{scrop.row.newQuantity}}</span>
					
				</template>
				</el-table-column>
			</el-table>
				<span slot="footer" class="dialog-footer">
					<el-button @click="dialogTableVisible = false">{{$t('other.a106')}}</el-button>
				
				</span>
		</el-dialog>
        <!-- 创建转仓单 -->
        <el-dialog
        :title="$t('other.a2770')"
        :visible.sync="dialogVisible"
        width="30%"
        >
        <div>
        {{$t('other.a879')}}：
        <el-select size="medium" class="kvhkfn" v-model="sellerId" :placeholder="$t('other.a2771')">
            <el-option v-for="item in sellerOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        </div>
        <div>
        {{$t('other.a2758')}}：
        <el-select size="medium" class="kvhkfn" v-model="storeId" :placeholder="$t('other.a2753')">
            <el-option v-for="item in storeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        </div>
        <div>
            <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4}"
            :placeholder="$t('other.a2772')"
            v-model="textarea3">
            </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">{{$t('other.a106')}}</el-button>
            <el-button type="primary" @click="createTransferOrder()">{{$t('other.a2773')}}</el-button>
        </span>    
        </el-dialog>

		<div class="iuhgjnvk">{{$t('other.a2760')}}（{{total}}）</div>
        <div class="titile">
            <el-button size="medium" type="primary" @click="dialogVisible=true">{{$t('other.a2770')}}</el-button>
        </div>

        <div>
            <el-table
                :data="tableData"
                border
                style="width: 100%">
                <el-table-column :label="$t('other.a2755')" >
                    <template slot-scope="scope">
					<div>{{scope.row.transferId}}</div>
                    <div class="vijfk" v-if="scope.row.storeConfirmTime ">{{$t('other.a2761')}}</div>
                    <div class="linfi" v-if="!scope.row.storeConfirmTime ">{{$t('other.a2762')}}</div>

				</template>
                </el-table-column>

                <el-table-column :label="$t('other.a57')" >
                    <template slot-scope="scope">
					<div >{{$t('other.a2763')}}：{{scope.row.createTime ? scope.row.createTime : '--'}}</div>
                    <div >{{$t('other.a2764')}}：{{scope.row.sellerConfirmTime ? scope.row.sellerConfirmTime : '--'}}</div>
                    <div >{{$t('other.a2765')}}：{{scope.row.transferTime ? scope.row.transferTime : '--'}}</div>
                    <div >{{$t('other.a2766')}}：{{scope.row.storeConfirmTime ? scope.row.storeConfirmTime : '--'}}</div>
				</template>
                </el-table-column>
                <el-table-column :label="$t('other.a2756')" >
                    <template slot-scope="scope">
					<div>{{$t('other.a2756')}}：{{scope.row.storeName}}</div>
                    <div>{{$t('other.a2767')}}：{{scope.row.newStoreName}}</div>
				</template>
                </el-table-column>

                <el-table-column :label="$t('other.a2757')" >
                    <template slot-scope="scope">
					<div>{{$t('other.a579')}}：{{scope.row.oldStoreMsg ? scope.row.oldStoreMsg : $t('other.a354')}}</div>
                    <div>{{$t('other.a499')}}：{{scope.row.sellerMsg ? scope.row.sellerMsg : $t('other.a354')}}</div>
                   
				</template>
                </el-table-column>

                <el-table-column :label="$t('other.a33')" >
                    <template slot-scope="scope">
                        <span class="operate" v-show="scope.row.createTime && !scope.row.transferTime    &&  !scope.row.storeConfirmTime " @click="comfirm(scope.row)">{{$t('other.a2774')}}</span>
                        <span class="operate" v-show="scope.row.createTime && scope.row.transferTime  && scope.row.sellerConfirmTime   && !scope.row.storeConfirmTime " @click="comfirm(scope.row)">{{$t('other.a2713')}}</span>
                        <span class="kkgnk" v-show="scope.row.createTime && scope.row.transferTime  && scope.row.sellerConfirmTime  && scope.row.storeConfirmTime " @click="viewMore(scope.row)">{{$t('other.a600')}}</span>
                        <span class="jmhv"  v-show="scope.row.createTime && !scope.row.transferTime  &&  scope.row.sellerConfirmTime  &&  !scope.row.storeConfirmTime "   @click="deleteItem(scope.row)"> {{$t('other.a312')}}</span>
				    </template>
                </el-table-column>
       
            </el-table>
        </div>
		
	</div>
</template>

<script>
	import api from '../../api/api.js'
    import transferApi from '../../api/moudles/transfer'
	import utils from '../../utils/utils.js'
	import {mapState, mapActions, mapMutations,} from 'vuex'
    import newOrders from '../../api/moudles/newOrders.js'
	export default {
		data() {
			return {
				dialogVisible:false,
                dialogTableVisible:false,
                sellerOption:[],
                sellerId:null,
                storeOptions:[],
                itemDetail:[],
                sellerpurchaseAmout:0,
                actualAmout:0,
                storeId:null,
                textarea3:null,
                total:0,
                dataParams:{
                    end:null,
                    offset:100,
                    page:0,
                    shopIds:[],
                    start:null,
                    storeIds:[],
                    userId:null
                },
                tableData:[]
			}
		},
	
		computed: {
			...mapState({
				userId: state => state.shopaccess.userInfo.userId
			}),

		},
		watch: {
            dialogVisible(){
                if(!this.dialogVisible){
                    this.sellerId=null
                    this.storeId=null
                    this.textarea3=null
                }
            },
            dialogTableVisible(){
                if(!this.dialogTableVisible){
                    this.sellerpurchaseAmout=0
                    this.actualAmout=0
                    
                }
            },

		},
		created() {
            this.init()
			
			
		},
		
		methods: {
            comfirm(item){
                console.log('item',item)
                this.$router.push({
                    path:'/checktransfer',
                    query:{
                        obj:JSON.stringify(item)
                    }
                })
            },

            viewMore(item){
                this.itemDetail=item.items
                item.items.forEach(p =>  {
                    this.sellerpurchaseAmout+=p.oldQuantity
                    this.actualAmout+=p.newQuantity
                })
                this.dialogTableVisible=true
                console.log(this.itemDetail)
            },
            deleteItem(item){
                item.userId=this.userId
                let parms=JSON.parse(JSON.stringify(item))
                parms.createTime=null
                parms.transferTime=null
                parms.sellerConfirmTime=null
                parms.storeConfirmTime=null
                

                this.$confirm(this.$t('other.a608'), this.$t("other.a142"), {
                confirmButtonText: this.$t('other.a235'),
                cancelButtonText: this.$t('other.a146'),
                type: 'warning'
                }).then(() => {
                    transferApi
                    .deleteStoreProduct(parms)
                    .then(res => {
                    if(res.code === 200 ){
                    console.log('desc',res.data)
                    this.$message.success(this.$t('other.a565'))
                    this.init()
                    }else{
                    this.$message.warning(res.msg)
                    }
                    })
                })
            },

           

            init(){
                this.sellerOption=utils.getSellerBystoreId()
                this.storeOptions=utils.getStoreOptions()
                this.dataParams.userId=this.userId
                this.dataParams.shopIds=JSON.parse(localStorage.getItem('userInfo')).shopIds
                this.dataParams.storeIds=utils.getAllstorIdsByisUsedForTrue()
                console.log(this.dataParams)
                this.getTransferOrder()
            },

            getTransferOrder(){
                transferApi
                .getTransferOrder(this.dataParams)
                .then(res => {
                if(res.code === 200 ){
                console.log('desc',res.data)
                res.data.items.forEach(p => {
                    
                    p.storeName= utils.showStoreName(p.oldStoreId)
                    p.newStoreName=p.newStoreId ? utils.showStoreName(p.newStoreId) : this.$t('other.a1064')
                    p.createTime=p.createTime ? utils.renderTime(p.createTime) : null
                    p.transferTime=p.transferTime ? utils.renderTime(p.transferTime) : null
                    p.sellerConfirmTime=p.sellerConfirmTime ? utils.renderTime(p.sellerConfirmTime) : null
                    p.storeConfirmTime=p.storeConfirmTime ? utils.renderTime(p.storeConfirmTime) : null
                })
                this.tableData=res.data.items
                this.total=res.data.count

              
                this.dialogVisible=false
                }else{
                this.$message.warning(res.msg)
                }
                })
            },



            createTransferOrder(){
                if(!this.sellerId || !this.storeId){
                    this.$message.warning(this.$t('other.a2769'))
                    return 
                }


                transferApi
                .createTransferOrder({
                    sellerId:this.sellerId,
                    oldStoreId:this.storeId,
                    oldStoreMsg:this.textarea3,
                    userId:this.userId
                })
                .then(res => {
                if(res.code === 200 ){
                console.log('desc',res.data)
                this.$message.success(this.$t('other.a2725'))
                this.init()
                this.dialogVisible=false
                }else if(res.code === 500){
                    this.$confirm(res.msg, this.$t("other.a142"), {
                    confirmButtonText: this.$t('other.a1552'),
                    cancelButtonText: false,
                    type: 'warning'
                    }).then(() => {})

                }else{
                this.$message.warning(res.msg)
                }
                })
            },
			

		

		
		}
	}
</script>

<style lang='scss' scoped>
.transfer_box{

    .picbox{
        width: 60px;
        height: 60px;
        overflow: hidden;
    }

    .kvhkfn{
        margin-bottom:10px
    }

    .titile{
        text-align: right;
        margin-right: 30px;
        margin-bottom: 20px;
    }

    .kkgnk{
        cursor: pointer;
        color: #409eff;
    }

    .vbfkh{
		color: rgb(255, 82, 69);
		font-size: 20px;
		margin-right: 15px;
        
	}

    .vbfk{
		color: rgb(0, 199, 163);
		font-size: 20px;
		margin-right: 15px;
	}

    .operate{
        color: red;
        cursor: pointer;
        margin-right: 10px;
    }

    .vijfk{
        color:rgb(0, 199, 163);
        font-weight: bold;
        margin-top: 10px;
        
    }

    .linfi{
        color:rgb(255, 82, 69);
        font-weight: bold;
    }

    .jmhv{
        cursor: pointer;
        margin-right: 10px;
    }

    .iuhgjnvk{
        font-size: 23px;
    }
}
	
</style>
